import React from 'react'
import styled from 'styled-components'

import { formatScreenshotTimestamp } from '~/core/utils/dates'
import { translate } from '~/core/translate'
import Image from '~/components/common/image'
import { Body01 } from '~/components/common/typography'
import themes from '@8x8/oxygen-theme'

const Container = styled.div`
  height: 100%;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const StyledNameLabel = styled(Body01)`
  background-color: ${themes.dark.ui05};
  border-radius: 6px;
  bottom: 16px;
  color: white;
  left: 50%;
  padding: 8px;
  position: absolute;
  transform: translate(-50%, 0);
`

const EmphasisedSlide = ({ screenshot }) => {
  const { link, name, timestamp } = screenshot

  return (
    <Container>
      <Image alt='' src={link} />
      <StyledNameLabel>
        {`${translate('presented_by_at', { name })} ${formatScreenshotTimestamp(timestamp)}`}
      </StyledNameLabel>
    </Container>
  )
}

export default EmphasisedSlide
